import { Module } from 'vuex'
import { PTRootState } from '@pt/store/index.type'

interface DetailDialogModel {
  visible: boolean
  width: number
  title: string
  id: string
  type: 'ps' | 'gmaker'
  project_type: 'doc' | 'playable' | 'playsmart'
  from: number
}

interface DetailState {
  detailDialog: DetailDialogModel
}

const DetailModule: Module<DetailState, PTRootState> = {
  namespaced: true,

  state: {
    detailDialog: {
      visible: false,
      width: 720,
      title: '',
      id: '',
      type: 'gmaker',
      project_type: 'playsmart',
      from: 1,
    },
  },

  mutations: {
    setDetailDialog(state, data: Partial<DetailDialogModel>) {
      Object.assign(state.detailDialog, data)
    },
  },
}

export default DetailModule
